import {Component, EventEmitter, OnInit, Output, NgZone, Input, ChangeDetectionStrategy} from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";
import {iInpost as iDPDPoint} from "../../model/CartModel";
import {CartService} from "../../services/cart.service";
import {ScriptLoaderService} from "../../services/scripts.service";

@ComponentAsElement('v-cart-pdp-element')
@Component({
  selector: 'v-cart-dpd',
  templateUrl: './cart-dpd.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartDpdComponent implements OnInit {
  @Input() widget: boolean;
  @Input() error: boolean;
  @Input('api-key') apiKey: string;
  @Output() defineDPDPointCode: EventEmitter<null|string> = new EventEmitter();
  @Output() defineDPDPoint: EventEmitter<null|iDPDPoint> = new EventEmitter();
  showDPDMap;
  @Input('point') selectedDPDPoint: iDPDPoint;
  showSelectedDPDPoint = false;
  pointName = '';

  constructor(
    private cartService: CartService,
    private ngZone: NgZone,
    private scriptLoaderService: ScriptLoaderService)
  { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.widget && this.initDPD();

    if(this.selectedDPDPoint) {
      this.showDPDMap = false;
      this.showSelectedDPDPoint = true;
    }
    else {
      this.showDPDMap = true;
      this.showSelectedDPDPoint = false;
    }
  }

  private selectDPD(_point: string) {
    const point = _point;

    this.defineDPDPointCode.emit(point);
  }

  public initDPD() {
    this.showDPDMap = true;
    window['pointSelected'] = (point) => this.selectDPD(point)
    this.scriptLoaderService.load('dpdwidget');
  }

  newPoint() {
    this.cartService.clearMethods();
    Object.keys(this.selectedDPDPoint).forEach(key => {
      this.selectedDPDPoint[key] = ''
    });
    this.defineDPDPoint.emit(null);
    this.showSelectedDPDPoint = false;
    this.widget = true;
  }
}
